import { Amplify } from "aws-amplify";
import { Header } from "components/views/Header";
import { PasswordChangeModal } from "components/login/PasswordChangeModal";
import { GroupManagement, SubjectManagement, UserManagement } from "pages";
import { Confirm } from "pages/auth/Confirm";
import { Login } from "pages/auth/Login";
import { FileManagement } from "pages/FileManagement";
import { InterviewManagement } from "pages/InterviewManagement";
import { MonitorManagement } from "pages/MonitorManagement";
import { ScenarioManagement } from "pages/ScenarioManagement";
import { useAuth } from "providers/AuthProvider";
import { useConsoleState } from "providers/ConsoleStateProvider";
import { useLoadingState } from "providers/LoadingProvider";
import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { BrowserRouter } from "react-router-dom";

import awsconfig from "aws-exports";
import { Report } from "pages/Report";
import { StyledRoutesExceptHeader } from "routes/styled";
import { FileDLManagement } from "pages/FIleDLManagement";
import { MailHistoryManagement } from "pages/MailHistoryManagement";

type PrivateRouteProps = {
  path: string;
  exact?: boolean;
  Component: React.FC;
};

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  path,
  exact,
  Component,
}) => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <Route
        path={path}
        exact={exact}
        render={({ location }) =>
          isAuthenticated ? (
            <Component />
          ) : (
            <Redirect
              to={{
                pathname: "/auth/login",
                state: { from: location },
              }}
            />
          )
        }
      />
    </>
  );
};

const AuthRoute: React.FC = () => {
  return (
    <Switch>
      <Route path="/auth/login" component={Login} />
      <Route exact path="/auth/confirm" component={Confirm} />
      <Redirect to="/auth/login"></Redirect>
    </Switch>
  );
};

export const Routes = () => {
  const { setLoading } = useLoadingState();

  const { userId } = useConsoleState();

  if (userId !== "" && userId !== null && userId !== undefined) {
    awsconfig.aws_appsync_authenticationType = "AMAZON_COGNITO_USER_POOLS";
    Amplify.configure(awsconfig);
  } else {
    awsconfig.aws_appsync_authenticationType = "AWS_IAM";
    Amplify.configure(awsconfig);
  }

  const [showPasswordChange, setShowPasswordChange] =
    React.useState<boolean>(false);

  const closePasswordChangeModal = () => {
    setShowPasswordChange(false);
    setLoading(false);
  };

  const clickPasswordChangeHandler = () => {
    setShowPasswordChange(true);
  };

  return (
    <>
      <BrowserRouter>
        <Header
          clickPasswordChangeHandler={clickPasswordChangeHandler}
          className="ipc_header"
        />
        <StyledRoutesExceptHeader>
          <Switch>
            <Route path="/auth" component={AuthRoute} />
            <PrivateRoute path="/group" Component={GroupManagement} />
            <PrivateRoute path="/user" Component={UserManagement} />
            <PrivateRoute path="/subject" Component={SubjectManagement} />
            <PrivateRoute path="/interview" Component={InterviewManagement} />
            <PrivateRoute path="/report" Component={Report} />
            <PrivateRoute path="/scenario" Component={ScenarioManagement} />
            <PrivateRoute path="/file" Component={FileManagement} />
            <PrivateRoute path="/fileDL" Component={FileDLManagement} />
            <PrivateRoute path="/monitor" Component={MonitorManagement} />
            <PrivateRoute
              path="/mailHistory"
              Component={MailHistoryManagement}
            />
            <Redirect to="/auth" />
          </Switch>
        </StyledRoutesExceptHeader>
      </BrowserRouter>
      {showPasswordChange && (
        <PasswordChangeModal
          closePasswordChangeModal={closePasswordChangeModal}
          closeHandler={closePasswordChangeModal}
        />
      )}
    </>
  );
};
